const gmail = {
  inbox: "תיבת דואר",
  unread: "לא נקראו",
  from: "מאת",
  noMessages: "אין הודעות חדשות",
  noAccount: "לא חובר חשבון Gmail",
  connectAccount: "חבר חשבון בהגדרות",
  openInGmail: "פתח ב-Gmail",
  refreshing: "מרענן...",
} as const;
export default gmail;
